import noop from 'lodash/noop';
import { createActions } from 'redux-actions';
export const dashboardActions = createActions({
    DASHBOARD_GET_ALL_QUEUES: [
        (payload) => payload,
        (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    DASHBOARD_GET_AGENT_QUEUES: [
        (payload) => payload,
        (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    DASHBOARD_GET_QUEUES_BY_ID: [
        (payload) => payload,
        (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    DASHBOARD_CHANGE_QUEUES_TYPE: [
        (payload) => payload,
        (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    DASHBOARD_GET_ALL_QUEUES_V1: [
        (payload) => payload,
        (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    DASHBOARD_GET_AGENT_QUEUES_V1: [
        (payload) => payload,
        (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
}, 'DASHBOARD_GET_ALL_QUEUES_SUCCEEDED', 'DASHBOARD_GET_ALL_QUEUES_FAILED', 'DASHBOARD_GET_AGENT_QUEUES_SUCCEEDED', 'DASHBOARD_GET_AGENT_QUEUES_FAILED', 'DASHBOARD_GET_QUEUES_BY_ID_SUCCEEDED', 'DASHBOARD_GET_QUEUES_BY_ID_FAILED', 'DASHBOARD_WS_STATISTICS_QUEUE_CHANGED', 'DASHBOARD_GET_ALL_QUEUES_SUCCEEDED_V1', 'DASHBOARD_GET_ALL_QUEUES_FAILED_V1', 'DASHBOARD_GET_AGENT_QUEUES_SUCCEEDED_V1', 'DASHBOARD_GET_AGENT_QUEUES_FAILED_V1');
